import React from 'react'
import { Bold, Italic, Callout, Card, Title, Text } from '@tremor/react'
import InvestmentComparisonChart from './InvestmentComparisonChart'
import RespVsWlQuickVisual from './RespVsWlQuickVisual'
import RespGrowthChart from './RespGrowthChart'

// MDX component mapping for styling and custom embeds
export const mdxComponents = {
  h1: (props: any) => <h1 className="text-4xl font-bold mt-8 mb-4" {...props} />,  
  h2: (props: any) => <h2 className="text-2xl font-bold text-blue-800 mt-8 mb-4" {...props} />,  
  h3: (props: any) => <h3 className="text-xl font-semibold text-blue-700 mt-6 mb-3" {...props} />,  
  p:  (props: any) => <p className="my-3 text-gray-700 leading-relaxed" {...props} />,  
  ul: (props: any) => <ul className="list-disc pl-6 my-4 space-y-2 text-gray-700" {...props} />,  
  ol: (props: any) => <ol className="list-decimal pl-6 my-4 space-y-2 text-gray-700" {...props} />,  
  li: (props: any) => <li className="mb-1" {...props} />,  
  strong: Bold,
  em: Italic,
  img: (props: any) => <img className="rounded-lg" loading="lazy" {...props} />,  
  Callout,
  Card,
  Title,
  Text,
  // Shortcodes / custom components
  ChartTFSA: InvestmentComparisonChart,
  RespVsWlQuickVisual,
  RespGrowthChart,
}
